import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from '@/components/Layout/Layout';
import { Home } from '@/pages/Home/Home';
import { Category } from '@/pages/Category/Category';
import { Product } from '@/pages/Product/Product';
import { Checkout } from '@/pages/Checkout/Checkout';
import { Confirmation } from '@/pages/Confirmation/Confirmation';
import { Orders } from '@/pages/Orders/Orders';
import { Sso } from '@/pages/Sso/Sso';
import { NotFound } from '@/pages/NotFound/NotFound';

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="c">
          {/* /c alone is meaningless — send it to the full listing. */}
          <Route index element={<Navigate to="/c/all" replace />} />
          <Route path=":categoryId" element={<Category />} />
        </Route>
        <Route path="p/:productId" element={<Product />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="order/confirmed" element={<Confirmation />} />
        <Route path="orders" element={<Orders />} />
        {/* Landing spot for playTUB's "open the marketplace" handoff. Not linked
            from anywhere here — it is arrived at with a ticket in the fragment. */}
        <Route path="sso" element={<Sso />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
